export default "__VITE_ASSET__v9CYX5qp__"